export * from './ArticleTextNews';
